import { axiosObject } from "../config";

export interface SharePropertyBrochurePayload {
  mobile: string;
  property_uuid: string;
  property_document_uuid: string;
}

export function sharePropertyBrochure(payload: SharePropertyBrochurePayload) {
  return new Promise((resolve, reject) => {
    let uri = "auction/share-property-link";
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
